/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'
import { Theme } from '@themes/theme'

const Color = (theme: Theme) => css`
  width: inherit;
  height: auto;
`
export default class PageResetIco extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="15.688" height="16.581" viewBox="0 0 15.688 16.581" css={Color} className="page-reset-ico">
        <defs>
          <clipPath id="clip-path">
            <rect id="사각형_13098" data-name="사각형 13098" width="15.688" height="16.581" fill="none"/>
          </clipPath>
        </defs>
        <g id="그룹_34552" data-name="그룹 34552" clipPath="url(#clip-path)">
          <path id="패스_51437" data-name="패스 51437"
                d="M11.83,15.416l-.373.213A8.036,8.036,0,0,1,.71,12.594l-.035-.071H.666A.9.9,0,0,1,1,11.369l.035-.018a.876.876,0,0,1,.683-.089.933.933,0,0,1,.559.435,6.225,6.225,0,0,0,8.52,2.219l.044-.027a6.26,6.26,0,0,0,2.2-8.5A6.188,6.188,0,0,0,2.9,4.526c-.106.151-.16.24-.222.328l-.124.213L6.017,5A.817.817,0,0,1,6.062,6.63l-5.13.115a.8.8,0,0,1-.808-.8L0,.834A.82.82,0,0,1,.8,0a.859.859,0,0,1,.843.8L1.7,3.266l.222-.248a8.1,8.1,0,0,1,1.7-1.411,8.079,8.079,0,0,1,11,2.9,8.1,8.1,0,0,1-2.8,10.907"
                transform="translate(0 0)" fill="#eee"/>
        </g>
      </svg>
    )
  }
}
